webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return staticDir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return links; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pages; });

var staticDir = '/static/';

var profile = {
  name: 'Kyle He',
  avatar: 'avatar.jpg',
  description: 'Web Developer'
};

var links = [{
  name: 'Blog',
  icon: 'news.svg',
  href: '/blog/',
  tags: ['publication']
}, {
  name: 'Github',
  icon: 'github.svg',
  href: 'https://github.com/599316527/',
  tags: ['publication', 'programming']
}, {
  name: 'Twitter',
  icon: 'twitter.svg',
  href: 'https://twitter.com/kyleehee',
  tags: ['publication', 'sns']
}, {
  name: 'Instagram',
  icon: 'instagram.svg',
  href: 'https://www.instagram.com/ohyeskyle/',
  tags: ['publication', 'sns']
},
// {
//   name: 'Steam',
//   icon: 'steam.svg',
//   href: 'https://steamcommunity.com/id/kyleehe/',
//   tags: ['game', 'sns']
// },
// {
//   name: 'PS4',
//   icon: 'playstation.svg',
//   href: 'https://my.playstation.com/kyleehe',
//   tags: ['game', 'sns']
// },
{
  name: 'Telegram',
  icon: 'telegram.svg',
  href: 'https://telegram.me/kyleehee',
  tags: ['contact', 'im']
}, {
  name: 'iMessage',
  icon: 'imessage.svg',
  href: '#/page/imessage/',
  tags: ['contact', 'im']
}, {
  name: 'Mail',
  icon: 'mail.svg',
  href: '#/page/mail/',
  tags: ['contact']
}, {
  name: 'Paypal',
  icon: 'paypal.svg',
  href: 'https://paypal.me/kyleehe',
  tags: ['contact', 'payment']
}, {
  name: 'Alipay',
  icon: 'alipay.svg',
  href: '#/page/alipay/',
  tags: ['contact', 'payment']
}, {
  name: 'Zhihu',
  icon: 'zhihu.png',
  href: 'https://www.zhihu.com/people/ohyes',
  tags: ['publication', 'sns']
}];

var pages = [{
  name: 'iMessage',
  icon: 'imessage.svg',
  album: '',
  value: 'ohyes@hk1229.cn'
}, {
  name: 'Mail',
  icon: 'mail.svg',
  album: '',
  value: 'me@kylehe.me'
}, {
  name: 'Alipay',
  icon: 'alipay.svg',
  album: 'alipay-qrcode.png',
  value: 'hekai@vista.aero'
}];

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Links__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Links___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Links__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Page__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Music__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Music___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Music__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a,
    children: [{
      path: '/',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Links___default.a
    }, {
      path: '/page/:name',
      component: __WEBPACK_IMPORTED_MODULE_4__components_Page___default.a
    }, {
      path: '/music',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Music___default.a
    }]
  }]
}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(64),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  data: function data() {
    return {
      staticDir: __WEBPACK_IMPORTED_MODULE_0__data__["a" /* staticDir */],
      profile: __WEBPACK_IMPORTED_MODULE_0__data__["d" /* profile */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.handleTouchStart = function (_ref) {
      var touches = _ref.touches;

      var touch = touches[0];
      _this.previousTouchPosX = touch.clientX;
      _this.previousTouchPosY = touch.clientY;
      _this.previousTouchStartTime = Date.now();
    };
    this.handleTouchMove = function (evt) {
      var touches = evt.touches;
      if (touches.length > 1) {
        // 多指触控，不处理
        return;
      }

      var touch = touches[0];

      var deltaPosX = touch.clientX - _this.previousTouchPosX;
      var deltaPosY = touch.clientY - _this.previousTouchPosY;

      if (Math.abs(deltaPosY) > Math.abs(deltaPosX) * 7) {
        // 判断为纵向滚动，不做处理
        return;
      } else {
        // 否则锁定滚动
        // evt.preventDefault()
      }

      _this.previousTouchMoveTime = Date.now();
    };
    this.handleTouchEnd = function (_ref2) {
      var touches = _ref2.changedTouches;

      if (touches.length > 1) {
        return;
      }
      var touch = touches[0];
      var deltaPosX = touch.clientX - _this.previousTouchPosX;
      var touchEndTime = Date.now();
      var deltaTouchStartEnd = touchEndTime - _this.previousTouchStartTime;
      var deltaTouchMoveEnd = _this.previousTouchMoveTime - _this.previousTouchStartTime;
      if (deltaTouchMoveEnd < 120 && deltaTouchStartEnd < 140 && Math.abs(deltaPosX) > 180) {
        _this.$router.push('/music');
      }
    };
    window.addEventListener('touchstart', this.handleTouchStart, false);
    window.addEventListener('touchmove', this.handleTouchMove, false);
    window.addEventListener('touchend', this.handleTouchEnd, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('touchstart', this.handleTouchStart);
    window.removeEventListener('touchmove', this.handleTouchMove);
    window.removeEventListener('touchend', this.handleTouchEnd);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var itemBasis = 120;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Links',
  data: function data() {
    return {
      staticDir: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* staticDir */],
      links: __WEBPACK_IMPORTED_MODULE_1__data__["c" /* links */],
      clientWidth: 0,
      filters: {
        name: '',
        tags: []
      }
    };
  },

  computed: {
    itemWidth: function itemWidth() {
      var count = Math.floor(this.clientWidth / itemBasis);
      return Math.floor(this.clientWidth / count);
    },
    filteredLinks: function filteredLinks() {
      var _filters = this.filters,
          name = _filters.name,
          tags = _filters.tags;

      if (!name && !tags.length) {
        return this.links;
      }
      return this.links.filter(function (link) {
        return (!name || link.name.toLowerCase().indexOf(name) >= 0) && (!tags.length || link.tags.some(function (tag) {
          return tags.includes(tag);
        }));
      });
    }
  },
  methods: {
    updateClientWidth: function updateClientWidth() {
      this.clientWidth = this.$refs.container.clientWidth;
    },
    handleFilterClear: function handleFilterClear(type, value) {
      var _filters2 = this.filters,
          name = _filters2.name,
          tags = _filters2.tags;


      switch (type) {
        case 'name':
          name = '';
          break;
        case 'tag':
          tags = tags.filter(function (tag) {
            return tag !== value;
          });
          break;
      }

      var query = {};
      if (name) {
        query.name = name;
      }
      if (tags.length) {
        query.tags = tags.join(',');
      }

      this.$router.replace({ query: query });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.updateClientWidth();
    this.handleWindowResize = function () {
      _this.updateClientWidth();
    };
    window.addEventListener('resize', this.handleWindowResize, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(vm.filters, parseFilterQuery(to.query));
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.filters, parseFilterQuery(to.query));
    next();
  }
});

function parseFilterQuery(_ref) {
  var name = _ref.name,
      tags = _ref.tags;

  name = name ? name.toLowerCase().trim() : '';
  tags = tags ? tags.split(',').map(function (tag) {
    return tag.toLowerCase().trim();
  }).filter(function (tag) {
    return !!tag;
  }) : [];
  return { name: name, tags: tags };
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Music',
  data: function data() {
    return {
      musicHeight: 500
    };
  },

  methods: {
    updateMusicHeight: function updateMusicHeight() {
      this.musicHeight = Math.max(document.documentElement.clientHeight - this.$refs.banner.clientHeight, 400);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.updateMusicHeight();
    this.handleWindowResize = function () {
      _this.updateMusicHeight();
    };
    window.addEventListener('resize', this.handleWindowResize, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Page',
  data: function data() {
    return {
      staticDir: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* staticDir */],

      name: '',
      icon: '',
      album: '',
      value: ''
    };
  },

  methods: {
    copyValue: function copyValue() {
      copyText(this.value);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var name = to.params.name;
    // console.log('name', name)
    var page = __WEBPACK_IMPORTED_MODULE_1__data__["b" /* pages */].filter(function (page) {
      return page.name.toLowerCase() === name.toLowerCase();
    });
    if (page) {
      page = page[0];
    }
    if (page) {
      next(function (vm) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(vm, page);
      });
    } else {
      next(false);
    }
  }
});

function copyText(value) {
  var fakeElem = document.createElement('TEXTAREA');
  fakeElem.style.position = 'absolute';
  fakeElem.style.left = '-9999px';
  fakeElem.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
  fakeElem.readonly = true;
  fakeElem.value = value;
  document.body.appendChild(fakeElem);
  fakeElem.focus();
  fakeElem.setSelectionRange(0, value.length);
  try {
    document.execCommand('copy');
  } catch (err) {
    console.log('不支持复制: ' + err.message);
  }
  fakeElem.blur();
  document.body.removeChild(fakeElem);
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(14);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(62),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(61),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(65),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(63),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [(_vm.filters.name || _vm.filters.tags.length) ? _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "tip"
  }), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [(_vm.filters.name) ? _c('div', {
    staticClass: "item name"
  }, [_c('span', [_vm._v(_vm._s(_vm.filters.name))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.handleFilterClear('name')
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filters.tags), function(tag, i) {
    return _c('div', {
      key: i,
      staticClass: "item tag"
    }, [_c('span', [_vm._v(_vm._s(tag))]), _vm._v(" "), _c('span', {
      staticClass: "close",
      on: {
        "click": function($event) {
          _vm.handleFilterClear('tag', tag)
        }
      }
    })])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('div', {
    ref: "container",
    staticClass: "wrapper"
  }, _vm._l((_vm.filteredLinks), function(link) {
    return _c('div', {
      key: link.name,
      class: ( _obj = {
        link: true
      }, _obj['link-' + link.name.toLowerCase()] = true, _obj ),
      style: ({
        width: _vm.itemWidth + 'px'
      })
    }, [_c('div', {
      staticClass: "item"
    }, [_c('a', {
      attrs: {
        "href": link.href,
        "target": link.href.indexOf('http') === 0 ? '_blank' : '_self'
      }
    }, [_c('div', {
      staticClass: "icon",
      style: ({
        'background-image': ("url(" + (_vm.staticDir + link.icon) + ")")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(link.name))])])])])
    var _obj;
  }))])])
},staticRenderFns: []}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      'background-image': ("url(" + (_vm.staticDir + _vm.profile.avatar) + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.profile.name))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.profile.description))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "rick",
    attrs: {
      "title": "Via. https://twitter.com/damyata/status/936756526710104064"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('a', {
    staticClass: "back-btn",
    attrs: {
      "href": "#/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "icon",
    style: ({
      'background-image': ("url(" + (_vm.staticDir + (_vm.album || _vm.icon)) + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('a', {
    on: {
      "click": _vm.copyValue
    }
  }, [_vm._v(_vm._s(_vm.value))])])])
},staticRenderFns: []}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music"
  }, [_c('div', {
    ref: "banner",
    staticClass: "banner"
  }, [_c('a', {
    staticClass: "back-btn",
    attrs: {
      "href": "#/"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Music")])]), _vm._v(" "), _c('div', {
    staticClass: "applemusic"
  }, [_c('iframe', {
    style: ({
      height: _vm.musicHeight + 'px'
    }),
    attrs: {
      "src": "//tools.applemusic.com/embed/v1/album/1252032972?at=10lPYF"
    }
  })])])
},staticRenderFns: []}

/***/ })
],[21]);


// WEBPACK FOOTER //
// static/js/app.7564ba10fd3fb40c9f09.js